const POPUP_STORAGE_KEY = "wetheme-popup";

/**
 * ローカルストレージが使えるかどうか
 */
function hasLocalStorage() {
  try {
    return typeof Storage !== "undefined" && window.localStorage;
  } catch (e) {
    return false;
  }
}

/**
 * ポップアップの表示制御用 有効期限が切れている、または未設定かどうか
 */
function isExpiredOrNotSet() {
  if (!hasLocalStorage()) return true;

  const saved = window.localStorage.getItem(POPUP_STORAGE_KEY);
  if (saved) {
    try {
      const expiry = JSON.parse(saved).expiry;
      return Date.parse(expiry) <= Date.now();
    } catch (e) {
      console.warn("Unable to read popup expiry date", e);
      return true;
    }
  }
  return true;
}

/**
 * ローカルストレージに有効期限（n日後）を保存
 */
function setExpiry(days) {
  const expiryDate = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
  try {
    if (hasLocalStorage()) {
      localStorage.setItem(POPUP_STORAGE_KEY, JSON.stringify({ expiry: expiryDate.toISOString() }));
    }
  } catch (e) {
    console.warn("Unable to set popup expiry:", e);
  }
}

/**
 * テストモードかどうかをdata属性から判定
 * @param {HTMLElement} element - 例えば #popup など
 */
function isTestModeEnabled(element) {
  return element?.dataset?.popupTestMode === "true";
}

function showFn(element) {
  element.style.display = 'block';
}

/**
 * ポップアップ制御ロジックの起動関数
 * @param {Object} options
 *    - element: HTML要素（data-popup-test-mode属性参照）
 *    - skipDays: 非表示期間（日数）
 *    - delayMs: 表示までの遅延（ミリ秒）
 */
function controlPopup(element, delayMs = 1000) {
  const testMode = isTestModeEnabled(element);

  if (testMode) {
    showFn(element);  // テストモードでは毎回表示
  } else if (isExpiredOrNotSet()) {
    setTimeout(() => {
      showFn(element);
    }, delayMs);
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const popupElement = document.querySelector('#store-popup');

  if (!popupElement) return;

  controlPopup(popupElement, popupElement.dataset.popupDelay);
  document.querySelector(".popup-close-wrapper")?.addEventListener('click', () => {
    popupElement.style.display = 'none';
    setExpiry(popupElement.dataset.popupTime);
  });
});
